{
  "name": "@shopify/hydrogen",
  "publishConfig": {
    "access": "public",
    "@shopify:registry": "https://registry.npmjs.org"
  },
  "type": "module",
  "version": "2025.5.0",
  "license": "MIT",
  "main": "dist/index.cjs",
  "module": "dist/production/index.js",
  "types": "dist/production/index.d.ts",
  "sideEffects": false,
  "repository": {
    "type": "git",
    "url": "git+https://github.com/Shopify/hydrogen.git",
    "directory": "packages/hydrogen"
  },
  "scripts": {
    "build": "tsup --clean",
    "dev": "tsup --watch ./src --watch ../../node_modules/@shopify/hydrogen-react/dist/browser-prod/index.mjs",
    "typecheck": "tsc --noEmit",
    "test": "vitest run",
    "prepack": "npm run build",
    "test:watch": "vitest",
    "build-docs": "sh ./docs/build-docs.sh && npm run format",
    "format": "prettier --write \"{src,docs}/**/*\" --ignore-unknown",
    "preview-docs": "npm run dev --prefix ../../docs/preview"
  },
  "exports": {
    ".": {
      "types": "./dist/production/index.d.ts",
      "module": {
        "development": "./dist/development/index.js",
        "default": "./dist/production/index.js"
      },
      "require": "./dist/index.cjs",
      "import": {
        "development": "./dist/development/index.js",
        "default": "./dist/production/index.js"
      },
      "default": {
        "development": "./dist/development/index.js",
        "default": "./dist/production/index.js"
      }
    },
    "./vite": {
      "types": "./dist/vite/plugin.d.ts",
      "default": "./dist/vite/plugin.js"
    },
    "./storefront-api-types": "./dist/storefront-api-types.d.ts",
    "./storefront.schema.json": "./dist/storefront.schema.json",
    "./customer-account-api-types": "./dist/customer-account-api-types.d.ts",
    "./customer-account.schema.json": "./dist/customer-account.schema.json",
    "./package.json": "./package.json"
  },
  "typesVersions": {
    "*": {
      "storefront-api-types": [
        "./dist/storefront-api-types.d.ts"
      ],
      "customer-account-api-types": [
        "./dist/customer-account-api-types.d.ts"
      ]
    }
  },
  "files": [
    "dist"
  ],
  "dependencies": {
    "@shopify/hydrogen-react": "2025.5.0",
    "content-security-policy-builder": "^2.2.0",
    "isbot": "^5.1.21",
    "source-map-support": "^0.5.21",
    "type-fest": "^4.33.0",
    "use-resize-observer": "^9.1.0",
    "worktop": "^0.7.3"
  },
  "devDependencies": {
    "react-router": "7.6.0",
    "@react-router/dev": "7.6.0",
    "@shopify/generate-docs": "0.16.4",
    "@shopify/hydrogen-codegen": "*",
    "@testing-library/jest-dom": "^5.17.0",
    "@testing-library/react": "^14.0.0",
    "@types/source-map-support": "^0.5.10",
    "formdata-polyfill": "^4.0.10",
    "happy-dom": "^17.0.0",
    "react": "^18.2.0",
    "schema-dts": "^1.1.2",
    "vitest": "^1.0.4"
  },
  "peerDependencies": {
    "react-router": "7.6.0",
    "@react-router/dev": "7.6.0",
    "react": "^18.2.0",
    "vite": "^5.1.0 || ^6.2.1"
  },
  "peerDependenciesMeta": {
    "vite": {
      "optional": true
    }
  }
}
